<template>
  <v-row justify="center" align="center">
    <v-col cols="12">
      <v-banner icon="mdi-format-list-checkbox">
        Template Orders
        <template v-slot:actions v-if="development">
          <v-btn
            outlined
            color="blue darken-2"
            :to="{ name: 'TemplateOrdersCreate' }"
          >
            <v-icon left>edit</v-icon>Create Template
          </v-btn>
        </template>
      </v-banner>
    </v-col>

    <v-col md="12" sm="12" v-if="development">
      <TemplateProgress :step="1"></TemplateProgress>
    </v-col>

    <v-col cols="12" lg="8">
      <v-card outlined shaped>
        <v-card-title>
          <v-icon class="mr-2">info</v-icon>How It Works
        </v-card-title>
        <v-card-text>
          <div>
            Templates are custom product lists which can be fetched when you're
            adding products to your order.
          </div>
          <div class="mt-2">
            First create a template and give it a name to help you identify it
            later. Then simply add the products to your template.
          </div>
          <div class="mt-2">
            Finally when it comes time to place your order you'll be able to
            select your template via the 'templates', you can then choose which
            of them you'd like add to your basket.
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" v-if="!development">
      <div>This page is currently under development</div>
    </v-col>
    <v-col cols="12" v-else>
      <v-row justify="start" align="start" no-gutters>
        <v-col v-if="loadingTemplates" cols="12" lg="12" xs="12">
          <v-card class="mx-auto" outlined height="100%" loading>
            <v-card-title>Loading Templates...</v-card-title>
            <template slot="progress">
              <v-progress-linear
                color="blue darken-2"
                indeterminate
              ></v-progress-linear>
            </template>
          </v-card>
        </v-col>
        <v-col v-else cols="12" lg="12" xs="12">
          <v-card v-if="templates.length == 0" color="background" flat>
            <v-card-title>You currently have no templates</v-card-title>
          </v-card>

          <v-card
            v-else
            class="mb-4"
            outlined
            v-for="template in templates"
            :key="template.id"
            :to="{ name: 'TemplateOrdersEdit' }"
            @click="setSelected(template.id)"
          >
            <v-card-title>{{ template.name }}</v-card-title>
            <!-- <v-card-actions>
              <v-btn text color="error">Delete</v-btn>
              <v-spacer />
              <v-btn text color="blue darken-2">Select</v-btn>
            </v-card-actions>-->
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";

import TemplateProgress from "@/components/order/template/TemplateProgress.vue";

export default {
  components: {
    TemplateProgress,
  },

  data() {
    return {
      development: true,
      showCreate: false,
      loadingTemplates: false,
    };
  },

  computed: {
    templates() {
      return this.$store.getters.retrieveAllTemplates;
    },
  },

  async activated() {
    //When Activated we want to refresh our templates
    this.loadingTemplates = true;
    let templateResponse = await this.getTemplates();

    if (!templateResponse) {
      this.setSnackbar({ color: "error", text: "Error finding templates" });
    }

    this.loadingTemplates = false;
  },

  methods: {
    ...mapActions(["getTemplates", "setSnackbar", "setSelectedTemplate"]),

    setSelected(id) {
      this.setSelectedTemplate(id);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>